import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import OutlinedInput from '@mui/material/OutlinedInput';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';

import { getUserAlias } from 'store/recoverAccount-actions';

import Loading from 'components/UI/Loading/Loading';
import PhoneInputForm from 'components/UI/PhoneInputForm/PhoneInputForm';
import classes from './RecoverAccountFirstStep.module.css';

const RecoverAccountFirstStep = props => {
  const { t } = useTranslation(['recoverAccount']);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const { register, handleSubmit, watch } = useForm();
  const [lada, setLada] = useState('');
  const [phone, setPhone] = useState('');
  const [value, setValue] = useState();
  const [userEmailText] = watch(['userEmailText']);
  const recoverAccountData = useSelector(
    state => state.recoverAccountInfo
  );

  useEffect(() => {
    if (recoverAccountData.alias[0] === 'noUser') {
      setIsLoading(false);
    }
  }, [recoverAccountData]);

  useEffect(() => {
    props.changeErrorMessage(false);
  }, [lada, phone, userEmailText]);

  const handleChange = event => {
    setValue(event.target.value);
    props.setTypeAlias(event.target.value);
  };

  const phoneHandler = (lada, phone) => {
    setLada(`+${lada}`);
    setPhone(phone);
  };

  const onSubmit = async data => {
    setIsLoading(true);
    if (value === '1') {
      dispatch(getUserAlias(data.userEmailText, value));
    } else {
      dispatch(getUserAlias(`${lada}${phone}`, value));
    }
  };

  return (
    <>
      <FormControl>
        <RadioGroup value={value} onChange={handleChange}>
          <FormControlLabel
            value="1"
            control={<Radio />}
            label={t('email')}
          />
          <FormControlLabel
            value="2"
            control={<Radio />}
            label={t('phone')}
          />
        </RadioGroup>
      </FormControl>
      <form
        className={classes.formContainer}
        onSubmit={handleSubmit(onSubmit)}
      >
        {value === '1' && (
          <OutlinedInput
            className={classes.textField}
            {...register('userEmailText')}
            placeholder={t('email')}
          />
        )}
        {value === '2' && (
          <PhoneInputForm phoneHandler={phoneHandler} />
        )}
        {!isLoading ? (
          <aside>
            <Button
              className={classes.cancelBtn}
              variant="outlined"
              component={Link}
              to="/"
            >
              {t('cancel')}
            </Button>
            <Button
              className={classes.searchBtn}
              variant="contained"
              disabled={!value}
              type="submit"
            >
              {t('search')}
            </Button>
          </aside>
        ) : (
          <Loading />
        )}
      </form>
      <p className={classes.complementaryText}>
        {t('you_no_longer')}
      </p>
      <p className={classes.complementaryText}>
        {t('contact_us')}{' '}
        <span>
          {' '}
          <a
            className={classes.helpCenterBtn}
            href="http://ayuda.mayahii.com/"
            target="_blank"
            rel="noreferrer"
          >
            {' '}
            {t('help_center')}
          </a>
        </span>{' '}
        {t('restore_access')}
      </p>
    </>
  );
};

RecoverAccountFirstStep.propTypes = {
  // eslint-disable-next-line react/require-default-props
  setTypeAlias: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  changeErrorMessage: PropTypes.func
};

export default RecoverAccountFirstStep;
